var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95833 8.70833C3.95833 6.08871 6.08871 3.95833 8.70833 3.95833C11.328 3.95833 13.4583 6.08871 13.4583 8.70833C13.4583 11.328 11.328 13.4583 8.70833 13.4583C6.08871 13.4583 3.95833 11.328 3.95833 8.70833ZM16.393 15.2736L13.7053 12.5851C14.539 11.5132 15.0417 10.1698 15.0417 8.70833C15.0417 5.21629 12.2004 2.375 8.70833 2.375C5.21629 2.375 2.375 5.21629 2.375 8.70833C2.375 12.2004 5.21629 15.0417 8.70833 15.0417C10.1698 15.0417 11.5132 14.539 12.5851 13.7053L15.2736 16.393C15.428 16.5474 15.6307 16.625 15.8333 16.625C16.036 16.625 16.2387 16.5474 16.393 16.393C16.7026 16.0835 16.7026 15.5832 16.393 15.2736Z",
    fill: "#262261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.46cf391e3dceea7c9bda127347dfa5b1.svg";
export { ForwardRef as ReactComponent };